import Invoice from './Invoice'
import Accounts from './Accounts'
import Refill from './Refill'
import Transport from './Transport'
import Announce from './Announce'

export default {
  Invoice,
  Announce,
  Refill,
  Transport,
  Accounts
}



// WEBPACK FOOTER //
// ./src/components/Admin/index.js